import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Toast, ToastService } from '../toast.service';

/**
 * Renders the toast stack into the mockup's #toasts rail. One instance sits in
 * the root component; every colour, radius and shadow comes from the global
 * #toasts / .toast rules in _components.scss.
 *
 * aria-live="polite" on the container rather than on each toast: announcing
 * the region once lets the screen reader queue additions instead of
 * interrupting whatever the user is doing.
 */
@Component({
  selector: 'app-toast-host',
  templateUrl: './toast-host.html',
  styleUrl: './toast-host.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastHost {
  private readonly service = inject(ToastService);
  protected readonly toasts = this.service.toasts;

  /** Maps kind onto the existing .toast colour modifiers. warn keeps the gold default. */
  protected tone(toast: Toast): string {
    switch (toast.kind) {
      case 'success':
        return 'green';
      case 'error':
        return 'red';
      default:
        return '';
    }
  }

  protected dismiss(id: number): void {
    this.service.dismiss(id);
  }
}
